module.exports = __webpack_public_path__ + "ce1f8d51d1c801b587af85b0729192c8.png";